import { memo, Suspense } from 'react';
import Box from '@mui/material/Box';
import { Outlet } from 'react-router-dom';
import { useLayout } from '../../../contexts/LayoutContext';
import { styled } from '@mui/material';
import Footer from '../footer';


const StyledBox = styled(Box)(() => ({
    transition: '0.3s ease-in-out',
    flexDirection: 'column',
    alignSelf: "flex-end",
    minHeight: 'calc(100vh - 100px)',
    display: 'flex',
    backgroundColor: "#F1F1F1"
}));

const ChildLayout = memo(() => {
    const { drawerWidth, isMobile } = useLayout();
    return (
        <StyledBox
            key="layout"
            sx={{
                ml: { xs: 0, md: `${drawerWidth}px` },
                width: `calc(100% - ${isMobile ? 0 : drawerWidth}px)`,
                backgroundColor: "#F1F1F1",
                paddingX: { xs: "20px", md: "30px" },
            }}
        >
            <Box
                sx={{
                    display: "flex", flexDirection: "column",
                    gap: { xs: "20px", md: "30px" },
                    paddingTop: { xs: "26px", md: "30px" },
                    pb: { xs: "10px", md: "10px" },
                    flexGrow: 1,
                    // marginBottom: "60px"
                }}
            >
                <Suspense fallback={null}>
                    <Outlet />
                </Suspense>
            </Box>
            <Footer key="footer" />
        </StyledBox>
    );
});

export default ChildLayout;